const currentURL = window.location.href;
let configOption = "development";
let instrumentKey = "";
const config = {
  localhost: {
    api: {
      url: "http://localhost:3002"
    }
  },
  development: {
    api: {
      url: "https://funky-admin-api-dev.caravanstudiosapps.org/"
    },
    applicationInsight: {
      instrumentationKey: "12c1a9e7-4d6e-4f05-ae84-8bf612f1b4d9"
    }
  },
  stage: {
    api: {
      url: "https://funky-admin-api-stage.caravanstudiosapps.org/"
    },
    applicationInsight: {
      instrumentationKey: ""
    }
  },
  live: {
    api: {
      url: "https://funky-admin-api.caravanstudiosapps.org"
    },
    applicationInsight: {
      instrumentationKey: ""
    }
  }
};

switch (true) {
  case /localdev/.test(currentURL):
  case /localhost/.test(currentURL):
    configOption = "localhost";
    break;
  case /dev/.test(currentURL):
    configOption = "development";
    break;
  case /stage/.test(currentURL):
    configOption = "stage";
    break;
  case /wc/.test(currentURL):
    configOption = "live";
    break;
  default:
    configOption = "live";
    break;
}

export const API_URL = config[configOption].api.url;
if (
  config[configOption].applicationInsight &&
  config[configOption].applicationInsight.instrumentationKey
) {
  instrumentKey = config[configOption].applicationInsight.instrumentationKey;
}
export const INSTRUMENT_KEY = instrumentKey;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/config.ts